export function booleanStringToBooleanPrimitive(env: string): boolean {
  return env === 'true';
}